/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDisabledOff = createReactComponent("outline", "disabled-off", "IconDisabledOff", [["path", { "d": "M11 7a2 2 0 1 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M11 11v4h4l4 5", "key": "svg-1" }], ["path", { "d": "M15 11h1", "key": "svg-2" }], ["path", { "d": "M7 11.5a5 5 0 1 0 6 7.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconDisabledOff as default };
//# sourceMappingURL=IconDisabledOff.mjs.map
